(function () {
  // "Shop the look" drawer: a per-card modal listing the card's products.
  // Moves itself to <body> so the fixed overlay is not clipped by the slider
  // wrapper's transform/overflow. Cleaned up on shopify:section:unload.
  class ShopTheLookModal extends HTMLElement {
    constructor() {
      super();
      this._moved = false;
      this._onKeyup = (event) => {
        if (event.code && event.code.toUpperCase() === "ESCAPE") this.hide();
      };
    }

    connectedCallback() {
      if (this._moved) return;
      this._moved = true;
      document.body.appendChild(this);

      this.dialog = this.querySelector('[role="dialog"]');
      this.querySelectorAll("[data-stl-close], .modal-close-button").forEach(
        (el) => el.addEventListener("click", () => this.hide())
      );
      this.addEventListener("keyup", this._onKeyup);
    }

    show(opener) {
      this.openedBy = opener;

      document.body.classList.add("overflow-hidden");
      this.setAttribute("open", "");
      requestAnimationFrame(() => {
        if (this.hasAttribute("open") && typeof trapFocus === "function") {
          trapFocus(this, this.dialog || this);
        }
      });
    }

    hide() {
      this.removeAttribute("open");
      if (typeof removeTrapFocus === "function") removeTrapFocus(this.openedBy);
      document.body.classList.remove("overflow-hidden");
    }
  }

  if (!customElements.get("shop-the-look-modal")) {
    customElements.define("shop-the-look-modal", ShopTheLookModal);
  }

  // Remove body-appended modals whose owning section is torn down in the editor.
  if (!window.__themeShopTheLookUnload) {
    window.__themeShopTheLookUnload = true;
    document.addEventListener("shopify:section:unload", (event) => {
      const sectionId =
        event.target && event.target.id
          ? event.target.id.replace("shopify-section-", "")
          : null;
      if (!sectionId) return;
      document
        .querySelectorAll(`shop-the-look-modal[data-section-id="${sectionId}"]`)
        .forEach((modal) => modal.remove());
    });
  }
})();
